(function () {
  'use strict';

  const FR_MAP = {
    'nouveau':    'Nouveau',
    'sale':       'Solde',
    'solde':      'Solde',
    'bestseller': 'Meilleur vendeur',
    'exclusive':  'Exclusif',
    'coming soon': 'Bientôt disponible',
  };

  function translate(raw) {
    if (!raw) return '';
    const lang = (document.documentElement.lang || 'en').toLowerCase();
    return lang.startsWith('fr') ? (FR_MAP[raw.toLowerCase()] || raw) : raw;
  }

  function applyBadge(el, raw) {
    // Le metafield accepte « Texte » ou « Texte|#HEXCOULEUR ». Sans couleur explicite on laisse
    // variant-badge.css décider, qui est la source unique de la couleur par défaut.
    const pipe = (raw || '').indexOf('|');
    const text = pipe >= 0 ? raw.slice(0, pipe).trim() : (raw || '').trim();
    const color = pipe >= 0 ? raw.slice(pipe + 1).trim() : '';
    const label = translate(text);

    el.style.backgroundColor = color;

    if (label) {
      el.textContent = label;
      el.classList.add('is-visible');
    } else {
      el.textContent = '';
      el.classList.remove('is-visible');
    }
  }

  function getBadgeForCheckedSwatch(card, badgeMap) {
    // Cherche le swatch coché → variant ID → badge
    const checked = card.querySelector(
      '.product-card__swatch-list input:checked, .product-card__variant-list input:checked'
    );
    if (checked && checked.dataset.variantId) {
      const vid = checked.dataset.variantId;
      if (Object.prototype.hasOwnProperty.call(badgeMap, vid)) {
        return badgeMap[vid];
      }
    }
    // Fallback : premier variant qui a un badge dans la map
    for (var key in badgeMap) {
      if (Object.prototype.hasOwnProperty.call(badgeMap, key) && badgeMap[key]) {
        return badgeMap[key];
      }
    }
    return '';
  }

  function initCard(card) {
    const badgeEl = card.querySelector('.card-variant-badge');
    if (!badgeEl) return;

    let badgeMap = {};
    try {
      badgeMap = JSON.parse(card.dataset.badgeMap || '{}');
    } catch (e) {
      console.warn('[collection-badge] JSON parse error on', card, e);
      return;
    }

    // Badge au chargement : basé sur le swatch coché (pas data-default-badge)
    applyBadge(badgeEl, getBadgeForCheckedSwatch(card, badgeMap));

    const fieldset = card.querySelector(
      '.product-card__swatch-list[data-option-position], .product-card__variant-list[data-option-position]'
    );
    if (!fieldset) return;

    // Hover → prévisualise le badge du variant survolé
    fieldset.querySelectorAll('label').forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        const input = document.getElementById(label.htmlFor)
                   || label.previousElementSibling
                   || label.querySelector('input');
        if (!input) return;
        const vid = input.dataset.variantId || '';
        applyBadge(badgeEl, Object.prototype.hasOwnProperty.call(badgeMap, vid) ? badgeMap[vid] : '');
      });
    });

    // Mouseleave du fieldset → restaure le badge du swatch coché
    fieldset.addEventListener('mouseleave', function () {
      applyBadge(badgeEl, getBadgeForCheckedSwatch(card, badgeMap));
    });

    // Clic sur un swatch → met à jour le badge persistant
    fieldset.addEventListener('change', function (e) {
      if (e.target.tagName !== 'INPUT') return;
      const vid = e.target.dataset.variantId || '';
      const newBadge = Object.prototype.hasOwnProperty.call(badgeMap, vid) ? badgeMap[vid] : '';
      card.dataset.defaultBadge = newBadge;
      applyBadge(badgeEl, newBadge);
    });
  }

  function init() {
    document.querySelectorAll('product-card[data-badge-map]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();